///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomerLocationDTO, CustomerLocationExtendedDTO } from '../../generated/shared-types.model';
import { CurrenciesList, Currency } from './currencies-list';

@Injectable()
export class GtthCustomerLocationService {
    private readonly API_URL = 'api/customer-location';
    private readonly currenciesList = CurrenciesList;

    constructor(private readonly http: HttpClient) {}

    getAvailableLocations(): Observable<CustomerLocationDTO[]> {
        return this.http.get<CustomerLocationDTO[]>(`${this.API_URL}`).pipe(
            map((locationList: CustomerLocationDTO[]) => {
                return this.sortAlphabetically(locationList, 'name');
            }),
            catchError(() => of([]))
        );
    }

    getLocationExtended(locationId: string): Observable<CustomerLocationExtendedDTO> {
        return this.http.get<CustomerLocationExtendedDTO>(`${this.API_URL}/${locationId}`).pipe(catchError(() => of(undefined)));
    }

    save(customerLocation: CustomerLocationDTO): Observable<CustomerLocationDTO> {
        const copy: CustomerLocationDTO = { ...customerLocation };
        return this.http.post<CustomerLocationDTO>(this.API_URL, copy).pipe(catchError(() => of(undefined)));
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${this.API_URL}/${id}`);
    }

    getCurrenciesList(): Currency[] {
        return this.currenciesList;
    }

    getCurrencySymbolByCode(code: string): string {
        const currency = this.currenciesList.find((item) => {
            return item.code === code;
        });
        return currency ? currency.symbol : undefined;
    }

    private sortAlphabetically(locationList: CustomerLocationDTO[], param: string): CustomerLocationDTO[] {
        return locationList.sort((locationA, locationB) => {
            const sortA = locationA[param].toString().toLowerCase();
            const sortB = locationB[param].toString().toLowerCase();
            if (sortA > sortB) {
                return 1;
            }
            if (sortA < sortB) {
                return -1;
            }
            return 0;
        });
    }
}
